<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 3V7"
      :stroke="clr ? clr : '#56606B'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18 5H22"
      :stroke="clr ? clr : '#56606B'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14 5H5C3.895 5 3 5.895 3 7V19C3 20.105 3.895 21 5 21H18C19.105 21 20 20.105 20 19V11"
      :stroke="clr ? clr : '#56606B'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.96642 14.4666L8.47042 12.0806C8.81942 11.5276 9.59642 11.4526 10.0444 11.9286L11.1194 13.0706L12.2464 10.6756C12.5934 9.93761 13.6314 9.90361 14.0264 10.6176L16.1804 14.5156C16.5484 15.1826 16.0654 15.9996 15.3044 15.9996H7.81242C7.02442 15.9996 6.54642 15.1326 6.96642 14.4666Z"
      :stroke="clr ? clr : '#56606B'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
